import {
  LayoutGrid, Target, FileText, Wrench, Users, Package, Palette, Calendar, BarChart3, Tag, Settings, Plug,
} from 'lucide-react';
import type { Role } from '@wrapforce/shared/constants';

export interface NavItem {
  labelKey: string;
  to: string;
  icon: typeof LayoutGrid;
  hiddenFor?: Role[];
}

// Exact order per §15.3.
export const NAV_OPS: NavItem[] = [
  { labelKey: 'nav.dashboard', to: '/', icon: LayoutGrid },
  { labelKey: 'nav.leads', to: '/leads', icon: Target, hiddenFor: ['installer'] },
  { labelKey: 'nav.quotes', to: '/quotes', icon: FileText, hiddenFor: ['installer'] },
  { labelKey: 'nav.jobs', to: '/jobs', icon: Wrench },
  { labelKey: 'nav.customers', to: '/customers', icon: Users, hiddenFor: ['installer'] },
  { labelKey: 'nav.inventory', to: '/inventory', icon: Package, hiddenFor: ['installer'] },
  { labelKey: 'nav.printWraps', to: '/print-wraps', icon: Palette, hiddenFor: ['installer'] },
  { labelKey: 'nav.calendar', to: '/calendar', icon: Calendar },
];

export const NAV_MANAGE: NavItem[] = [
  { labelKey: 'nav.pricing', to: '/pricing', icon: Tag, hiddenFor: ['installer', 'front_desk'] },
  { labelKey: 'nav.reports', to: '/reports', icon: BarChart3, hiddenFor: ['installer', 'front_desk'] },
  { labelKey: 'nav.integrations', to: '/integrations', icon: Plug, hiddenFor: ['manager', 'front_desk', 'installer'] },
  { labelKey: 'nav.settings', to: '/settings', icon: Settings },
];

export function filterForRole(items: NavItem[], role: Role | undefined): NavItem[] {
  return items.filter((item) => !role || !item.hiddenFor?.includes(role));
}
